import React from 'react';

/**
 * A captioned group of controls in a tab's control card. Every toggle, search
 * box, period navigator and button group sits under one, so each tab reads the
 * same way. Captions in use: Search, Mode, View, Period, Actions, Import,
 * Export, Group by.
 */
export default function ControlGroup({ label, className = '', children }) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest ml-1">{label}</span>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}
